<template>
  <header class="flex items-center justify-end" :class="{ 'sm:justify-between': showFreeUploads, 'py-0': isViewerPage, 'py-4': !isViewerPage }">
    <FreeUploadsCounter v-if="showFreeUploads" class="mr-2" />
    <LimitsBanner
      v-else-if="isPricingUpdateEnabled && isLoggedIn && hasActiveLimits && isLoaded && !isViewerPage"
      :percentage="averagePercentage"
      :label="headerLabel"
      :always-show-label="false"
      class="mr-2"
      data-testid="header-limits-banner"
      @upgrade="openLimitsModal"
    />
    <div class="flex gap-2">
      <ImpersonationIndicator />
      <template v-if="!isViewerPage">
        <AdminMenu v-if="isSystemAdmin" />
        <Notifications />
      </template>
    </div>
  </header>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import FreeUploadsCounter from './FreeUploadsCounter.vue';
import Notifications from './notifications/Notifications.vue';
import AdminMenu from './AdminMenu.vue';
import ImpersonationIndicator from './ImpersonationIndicator.vue';
import { LimitsBanner } from '@/storybook/templates/limits';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useUserStore } from '@/store/useUserStore';
import { useLimits } from '@/composables/useLimits';
import { useIsViewerPage } from '@/composables/useIsViewerPage';

const organizationStore = useOrganizationStore();
const userStore = useUserStore();
const { isSystemAdmin } = storeToRefs(userStore);
const { hasActiveLimits, isLoaded, averagePercentage, openLimitsModal, planTier, isPricingUpdateEnabled, limitUsages } = useLimits();

const isLoggedIn = computed(() => userStore.isLoggedIn);
const isViewerPage = useIsViewerPage();
const showFreeUploads = computed(() => {
  if (isPricingUpdateEnabled.value) {
    return false;
  }
  return organizationStore.free === true && !isViewerPage.value;
});

const uploadsUsage = computed(() => limitUsages.value.find(l => l.label === 'Uploads' && !l.disabled));
const headerLabel = computed(() => {
  if (planTier.value === 'free' && uploadsUsage.value) {
    return `FREE LIMIT: ${uploadsUsage.value.current}/${uploadsUsage.value.max}`;
  }
  return undefined;
});

// const { isMobile } = useMobileDetection();
</script>
